<div class="map-container"> 
  <form [formGroup]="mapForm">
    <div>
      <div class="scroll-display" (scroll)="onScroll($event)" *ngIf="phase == 1">
        <div
          [attr.data-testid]="'warning-direccion-cobertura'"
          class="map-state-warning"
          *ngIf="(showStateWarning || isBSAS) && !isMendoza"
        >
          <span>
            Lamentamos informarte que la dirección informada no corresponde a una zona de cobertura de Coca-Cola Andina.
            En este lugar opera otra franquicia de Coca-Cola. Para conocer con quién interactuar te sugerimos contactar
            al 0800-888-8888
          </span>
        </div>
        <div
          [attr.data-testid]="'warning-direccion-no-encontrada'"
          class="map-state-warning"
          *ngIf="showErrorConfirm"
        >
          <span>
            No pudimos encontrar la dirección ingresada. Por favor verificá los datos e intentá nuevamente.
          </span>
        </div>
        <div
         [attr.data-testid]="'warning-direccion-cobertura'"
        class="map-state-warning"
        *ngIf="showStateWarning && isMendoza " 
         >
        <span>
          ¡Gracias por tu consulta! Actualmente, la dirección indicada no está dentro de la zona de cobertura de Embotelladora del Atlántico SA. 
          Para orientarte sobre el contacto correspondiente en tu zona, podes comunicarte al 0810‑7777‑888.
        </span>
      </div>
        <div class="map-input-container">
          <div [@fadeInOut]>
            <app-select id="province-select" [labelText]="'Provincia'" [placeholder]="'Selecciona la provincia'" [required]="true"
               formControlName="locationState" [submitted]="submitted" [options]="provincias"></app-select>
          </div>
        </div>
        <div class="parent">
          <div class="map-input-container-city">
            <app-text-input
              id="city-input"
              [attr.data-testid]="'localidad'"
              [placeholder]="'Selecciona la ciudad'"
              [labelText]="'Ciudad'"
              formControlName="locationCity"
              [required]="true"
              [submitted]="submitted"
            ></app-text-input>
          </div>
          <div class="map-input-container-zip-code">
            <app-text-input
              id="zipcode-input"
              [attr.data-testid]="'codigo-postal'"
              [placeholder]="'Ej. 1234'"
              [labelText]="'Código postal'"
              [type]="'number'"
              formControlName="zipCode"
              [required]="true"
              [submitted]="submitted"
            ></app-text-input>  
          </div>
        </div>
        <!-- Checkbox Distribuidor -->
        <div class="distributor-checkbox-container" *ngIf="showDistributorCheckbox" [@fadeInOut]>
          <mat-checkbox formControlName="showDistributorFields" class="distributor-checkbox">
            Tengo un nro. de cliente de mi distribuidor anterior
          </mat-checkbox>
        </div>
        <div class="parent" *ngIf="showDistributorCheckbox && mapForm.get('showDistributorFields')?.value" [@fadeInOut]>
          <div class="map-input-container-street">
            <app-text-input
              id="razon-social-input"
              [labelText]="'Razón Social'"
              [placeholder]="'Ej: Autoservicio SA'"
              formControlName="erpDistributorClientName"
              [required]="true"
              [submitted]="submitted"
            ></app-text-input>
          </div>
          <div class="map-input-container-location-street">
            <app-text-input
              id="distributor-number-input"
              [labelText]="'Nro. Cliente Distribuidor'"
              [placeholder]="'Ej: 12345678'"
              formControlName="erpDistributorClientId"
              [required]="true"
              [submitted]="submitted"
            ></app-text-input>
          </div>
        </div>
        <div class="parent">
          <div class="map-input-container-street">
            <app-text-input
              id="street-input"
              [attr.data-testid]="'direction'"
              [placeholder]="'Ejemplo: Av. Corrientes'"
              [labelText]="'Calle'"
              formControlName="locationStreet"
              [required]="true"
              [submitted]="submitted"
            ></app-text-input>
            <label *ngIf="directionWarning" class="warning-label">
              Formato invalido, ej. a ingresar: "Honduras 123"
            </label>
            <button class="button-ubication" (click)="getAutomaticLocation()">
              <mat-icon class="icon-gps">gps_fixed</mat-icon>
              <label class="input-label"> Mi ubicación actual</label>
            </button>
          </div>
          <div class="map-input-container-location-street">
            <app-text-input
              id="number-input"
              class="map-input-street-location"
              [placeholder]="'Ej. 1234'"
              [labelText]="'Altura'"
              [type]="'number'"
              [required]="true"
              formControlName="locationStreetNumber"
              [submitted]="submitted"
            ></app-text-input>
          </div>
        </div>
        <div class="map-input-container">
          <app-text-input
            id="store-number-input"
            class="map-input-street-location"
            [labelText]="'Número de local (Opcional)'"
            [placeholder]="'Ejemplo: Local 5'"
            [type]="'text'"
            [max]="10"
            formControlName="depto"
            [submitted]="this.mapForm.get('depto')?.value.length > 10"
          ></app-text-input>
          <app-text-input
            id="between-streets-input"
            [labelText]="'Entre calles'"
            [type]="'text'"
            [min]="4"
            [max]="40"
            formControlName="entreCalles"
            [required]="true"
            [submitted]="submitted || this.mapForm.get('entreCalles')?.value.length > 40"
          ></app-text-input>
        </div>
      </div>
    </div>
  </form>
</div>
